import { boolean, object, string } from "yup";
import type { VendorCompany } from "~/models/VendorCompany";

export type CompanyVendor = {
	cautionaryNote: string;
	cautionaryNoteHtml: string;
	companyVendorPayload: { id: number } | null;
	completionReportImageRequired: boolean;
	completionReportImageRequiredByVendor: boolean;
	dealManagementTypeOwn?: boolean;
	defaultDealManagementType: "with_vendor" | "own";
	defaultEstimationBy: "vendor" | "company";
	email: string;
	id: number;
	inspectionReportImageRequired: boolean;
	inspectionReportImageRequiredByVendor: boolean;
	managementRequiredByVendor: boolean;
	name: string;
	seq: number;
	showTenantDefault: boolean;
	vendorCompany: VendorCompany | null;
	vendorEstimationRequired: boolean;
	vendorKey: string;
};

export const getCompanyVendorNameWithStatus = (
	companyVendor: CompanyVendor
): string =>
	`${
		(
			companyVendor.vendorCompany &&
				companyVendor.defaultDealManagementType === "own"
		) || companyVendor.vendorCompany === null
			? "非共有："
			: ""
	}${companyVendor.name}`;

export const convertToComboBoxOption = (
	companyVendor: CompanyVendor
): { label: string; value: string } => ({
	label: companyVendor.name,
	value: String(companyVendor.id)
});

export type CompanyVendorEdit = Omit<
	CompanyVendor,
	| "id"
	| "seq"
	| "companyVendorPayload"
	| "vendorEstimationRequired"
	| "managementRequiredByVendor"
	| "completionReportImageRequiredByVendor"
	| "inspectionReportImageRequiredByVendor"
	| "cautionaryNote"
	| "cautionaryNoteHtml"
>;

export const validationSchemaCompanyVendor = object().shape({
	email: string()
		.nullable()
		.email("メールアドレスの形式を確認してください")
		.when("invite", {
			is: true,
			// biome-ignore lint/suspicious/noThenProperty: Yupのwhen/then構文のため
			then: (schema) => schema.required("入力してください")
		}),
	invite: boolean(),
	name: string().required("入力してください")
});
